import React, { useEffect } from "react";
import SignUpFlow from "../Layout";
import RegisterForm from "../../../Components/Register/RegisterForm";
import RegisterForm2 from "../../../Components/Register/RegisterForm2";
import RegisterForm3 from "../../../Components/Register/RegisterForm3";
import RegisterForm4 from "../../../Components/Register/RegisterForm4";
import RegisterForm6 from "../../../Components/Register/RegisterForm6";
import { useAuth } from "./../../../hooks";
import { getSession } from "./../../../axios.config";
import { useNavigate } from "react-router-dom";
import { GetPinCodeDetails } from "./../../../api";
import BackToUnified from "../../../Components/sideBar/backToUnified.js";

function Registration() {
  const {
    stateVariable,
    setStateVariable,
    imagePreview,
    setImagePreview,
    setFormData,
    pincode,
    setErrors,
    formData,
    setLoading,
  } = useAuth();
  const user = JSON.parse(getSession("userId"));

  useEffect(() => {
    setFormData({
      ...user,
      pan: user?.panNumber,
      mobileNumber: user?.mobile?.replace(/^\+91\s*/, ""),
      dob: user?.dateOfBirth ? new Date(user?.dateOfBirth) : null,
    });
  }, []);

  const userDetails = user?.currentStep || user?.userData?.currentStep;

  const navigate = useNavigate();

  useEffect(() => {
    if (userDetails === "REGISTER") {
      setStateVariable(1);
    }
    if (userDetails === "PERSONAL_INFO") {
      setStateVariable(2);
    }
    if (userDetails === "SIGNUP") {
      setStateVariable(3);
    }
    if (userDetails === "DOC_UPLOAD") {
      setStateVariable(5);
    }
    if (userDetails === "SELFIEE_UPLOAD") {
      // setStateVariable(5);
      navigate("/redirect?status=success", {
        replace: true,
      });
    }
  }, []);

  useEffect(() => {
    async function getCityAndCountry() {
      try {
        if (pincode) {
          setLoading(true);
          const pinCodeCheck = await GetPinCodeDetails(pincode);
          if (pinCodeCheck) {
            setFormData({
              ...formData,
              state: pinCodeCheck?.data?.state,
              city: pinCodeCheck?.data?.city,
            });
            setLoading(false);
            // Clear the postcode error if API call succeeds
            setErrors((olderrors) => {
              const { postcode, ...rest } = olderrors;
              return rest;
            });
          }
        }
      } catch (error) {
        setLoading(false);
        setErrors((olderrors) => ({
          ...olderrors,
          postcode: error?.message || "Invalid PIN code",
        }));
      }
    }
    getCityAndCountry();
  }, [pincode]);

  const flow = {
    // Personal info Page
    1: (
      <RegisterForm
        setStateVariable={setStateVariable}
        stateVariable={stateVariable}
      />
    ),
    // Address Page
    2: (
      <RegisterForm2
        stateVariable={stateVariable}
        setStateVariable={setStateVariable}
      />
    ),
    //  Doc upload Page
    3: (
      <RegisterForm3
        setImagePreview={setImagePreview}
        setStateVariable={setStateVariable}
        stateVariable={stateVariable}
      />
    ),
    //  Doc Preview Page
    4: (
      <RegisterForm4
        setStateVariable={setStateVariable}
        imagePreview={imagePreview}
        stateVariable={stateVariable}
      />
    ),
    // Selfie Model Page
    5: <RegisterForm6 />,
  };
  const renderContent = () =>
    flow[stateVariable] || (
      <p className="text-center">Something went wrong Please Refresh!</p>
    );

  return (
    // h-[60dvh]
    <>
      <SignUpFlow
        styleProps={stateVariable === 5 ? " h-[60dvh] lg:h-full" : ""}
      >
        {renderContent()}
      </SignUpFlow>
      <BackToUnified />
    </>
  );
}

export default Registration;
